import React, { useEffect, createElement } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ContactSection } from '../components/ContactSection';
import { UtmCapture } from '../components/UtmCapture';
import { motion } from 'framer-motion';
import { Wind, Award, ShieldCheck, Rocket, Radio, MapPin, Palmtree, Music, Coffee, Package } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function WingFoilPage() {
  useEffect(() => {
    // Set meta tags for Wing Foil page
    document.title = "Wing Foil - גלيشה וריחוף | ביץ' קלאב מעגן";
    // Update or create meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'Wing Foil בכנרת - לעוף מעל המים! חוף מושלם עם רוח צד, הדרכות למתחילים ומתקדמים, ציוד חדיש');
    // Open Graph tags with image
    const ogTags = [{
      property: 'og:title',
      content: "Wing Foil - גלيشה וריחוף | ביץ' קלאב מעגן"
    }, {
      property: 'og:description',
      content: 'Wing Foil בכנרת - הדור הבא של גלيشה. חוף מושלם, הדרכות מקצועיות וציוד חדיש'
    }, {
      property: 'og:type',
      content: 'website'
    }, {
      property: 'og:image',
      content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/co1SZT3RTYumCS8rU85uzt/IMG-20250502-WA0017.jpg'
    }, {
      property: 'og:image:width',
      content: '1200'
    }, {
      property: 'og:image:height',
      content: '630'
    }, {
      property: 'og:url',
      content: window.location.href
    },
    // Twitter Card tags
    {
      property: 'twitter:card',
      content: 'summary_large_image'
    }, {
      property: 'twitter:title',
      content: "Wing Foil - גלيشה וריחוף | ביץ' קלאב מעגן"
    }, {
      property: 'twitter:description',
      content: 'Wing Foil בכנרת - לעוף מעל המים'
    }, {
      property: 'twitter:image',
      content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/co1SZT3RTYumCS8rU85uzt/IMG-20250502-WA0017.jpg'
    }];
    ogTags.forEach(tag => {
      let metaTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', tag.property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', tag.content);
    });
  }, []);
  return <div className="min-h-screen bg-white" dir="rtl" data-id="element-2636" data-mp="79tvdhnv4yx9">
      <UtmCapture data-id="element-2637" data-mp="7abvwqhk5zaz" />
      <Navigation data-id="element-2638" data-mp="7bwpodw1te7s" />

      {/* Hero Section */}
      <div className="relative h-[60vh] overflow-hidden" data-id="element-2639" data-mp="2c0m2fr9josr">
        <div className="absolute inset-0 bg-black/40 z-10" data-id="element-2640" data-mp="21o319dsutx0m" />
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/co1SZT3RTYumCS8rU85uzt/IMG-20250502-WA0017.jpg" alt="Wing Foil Activity" className="w-full h-full object-cover" style={{
        objectPosition: '60% 38%',
        transform: 'scale(2.0)'
      }} data-id="element-2641" data-mp="21nkzy2rc4slu" />
        <div className="absolute inset-0 z-20 flex flex-col items-center justify-center text-center text-white px-4" data-id="element-2642" data-mp="296u8xuvxipad">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-7xl font-bold mb-4" data-id="element-2643" data-mp="2dzncwgjkptle">
            Wing Foil
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-2xl md:text-3xl mb-2 font-medium" data-id="element-2644" data-mp="1lbrl9q8v2rvh">
            ווינג פויל
          </motion.p>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-xl md:text-2xl max-w-2xl font-light" data-id="element-2645" data-mp="208ihjqn8nngv">
            לעוף מעל המים - הדור הבא של גלisha
          </motion.p>
        </div>
      </div>

      {/* Content Section */}
      <div className="container mx-auto px-4 py-20" data-id="element-2646" data-mp="356m69utryo94">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-2647" data-mp="357xce1ap083e">
          <div data-id="element-2648" data-mp="3j6eunjhtwsdx">
            <h2 className="text-3xl font-bold text-[#0A5F8F] mb-6" data-id="element-2649" data-mp="3j6wz33enacwx">
              על הפעילות
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-8" data-id="element-2650" data-mp="3e8lo2pcm5wd4">
              ה-Wing Foil הוא הספורט הימי החדשני ביותר שכבש את העולם. הוא משלב
              כנף (Wing) המוחזקת ביד וגלשן עם סנפיר (Foil) המאפשר ריחוף מעל
              המים. התחושה היא של שקט מוחלט ומהירות, כמעט ללא חיכוך עם המים.
              הכנרת, עם הרוחות היציבות שלה בשעות הצהריים, היא המקום המושלם ללמוד
              ולהתקדם בספורט זה.
            </p>

            {/* Perfect Spot Section */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-gradient-to-br from-cyan-50 to-teal-50 border border-cyan-100 rounded-2xl p-6 mb-8" data-id="element-2651" data-mp="fpog2g86l70m">
              <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2" data-id="element-2652" data-mp="ycnnw1dp6mp1">
                <Wind className="w-7 h-7 text-cyan-600" data-id="element-2653" data-mp="kcwd09ih9mf9" />
                חוף מושלם לגלישת Wing
              </h3>
              <div className="space-y-3 text-gray-700" data-id="element-2654" data-mp="pao5p5qy5cki">
                <p className="flex items-start gap-2" data-id="element-2655" data-mp="ancrew3dregp">
                  <Wind className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-2656" data-mp="alrxn8ow3zjw" />
                  <span data-id="element-2657" data-mp="ffw9a593ovrb">
                    <strong data-id="element-2658" data-mp="fg5znty254xj">רוח צד (Side Shore)</strong> - תנאי רוח אידיאליים
                    לגלisha בטוחה
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-2659" data-mp="6mswlz6a4mxq">
                  <Wind className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-2660" data-mp="3nu4q6g29fy3n" />
                  <span data-id="element-2661" data-mp="3nw7qpu11h9mm">
                    <strong data-id="element-2662" data-mp="3ssy7kjko4993">רוח יציבה כמעט כל יום</strong> במשך העונה
                    (אפריל-אוקטובר)
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-2663" data-mp="39q5sx0w64o1r">
                  <MapPin className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-2664" data-mp="34y5xnlr1mjbi" />
                  <span data-id="element-2665" data-mp="34w1k0c3ce5y1">
                    <strong data-id="element-2666" data-mp="2zy9svkaiunuw">חניה קרובה למים</strong> - נוחות מקסימלית
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-2667" data-mp="2v0ht643mxxg5">
                  <Palmtree className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-2668" data-mp="2uxvivwpd13u8" />
                  <span data-id="element-2669" data-mp="3smp5k066ku32">
                    <strong data-id="element-2670" data-mp="3nodxnuzg4tnh">מדשאות</strong> לנוחות והכנת ציוד
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-2671" data-mp="3ipapw2s309bt">
                  <Package className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-2672" data-mp="3inpukaxy0mcw" />
                  <span data-id="element-2673" data-mp="3dp69ecr6bell">
                    <strong data-id="element-2674" data-mp="3dpy4znkrtcbv">מתקן לטליית ווינגים וקומפרסור</strong>
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-2675" data-mp="27818dlsijrd5">
                  <Music className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-2676" data-mp="22ark49gv1lqw" />
                  <span data-id="element-2677" data-mp="hta3t6r7e122">
                    <strong data-id="element-2678" data-mp="hu1npkbfuaci">מוזיקה ופינת קפה</strong> - אווירה מושלמת
                  </span>
                </p>
                <p className="flex items-start gap-2" data-id="element-2679" data-mp="msv3xki40fgd">
                  <Package className="w-5 h-5 text-cyan-600 mt-0.5 shrink-0" data-id="element-2680" data-mp="rrg45jxd2z4t" />
                  <span data-id="element-2681" data-mp="rpd4072hvpmd">
                    <strong data-id="element-2682" data-mp="whmsdinyohmj">אחסון ציוד</strong> - ניתן לאחסן את הציוד שלכם במקום
                  </span>
                </p>
              </div>
            </motion.div>

            <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-2683" data-mp="11j2ab1uue80p">
              יתרונות ה-Wing Foil
            </h3>
            <ul className="space-y-4 mb-8" data-id="element-2684" data-mp="1ahnzhfutklag">
              {['ציוד קל ונייד שקל להכין לפעילות', 'בטיחותי יותר מסוגי גלישות אחרים', 'עקומת למידה מהירה יחסית', 'תחושת ריחוף ייחודית וממכרת'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700" data-id="element-2685" data-mp="1feedlxn2d6t8" data-mpi={i}>
                  <div className="bg-cyan-100 p-1 rounded-full" data-id="element-2686" data-mp="3cavhwy5qbj0k">
                    <Rocket className="w-4 h-4 text-cyan-600" data-id="element-2687" data-mp="3h96o8ywtfbe1" />
                  </div>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="bg-gray-50 p-8 rounded-3xl border border-gray-100" data-id="element-2688" data-mp="1i1ghu0azzy1e">
            <h3 className="text-2xl font-bold text-[#0A5F8F] mb-6" data-id="element-2689" data-mp="1hzcg9p0knb4a">
              מה אנחנו מציעים?
            </h3>

            <div className="space-y-6" data-id="element-2690" data-mp="1rr05dj9nog2l">
              <div className="flex gap-4" data-id="element-2691" data-mp="1rsb4v6w2j1nw">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-2692" data-mp="1rtcjflcam6ad">
                  <ShieldCheck className="w-6 h-6 text-cyan-500" data-id="element-2693" data-mp="141nw6jebw80a" />
                </div>
                <div data-id="element-2694" data-mp="z3vsks4bmxg9">
                  <h4 className="font-bold text-lg mb-1" data-id="element-2695" data-mp="z4fd8glcvzxz">
                    הדרכות אישיות ברמות שונות
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-2696" data-mp="190s3t5lltxoi">
                    ליווי אישי מותאם לרמתך - ממתחילים מוחלטים ועד גולשים
                    מתקדמים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2697" data-mp="2kggotrfasmmo">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-2698" data-mp="2khru5voe62fw">
                  <Wind className="w-6 h-6 text-cyan-500" data-id="element-2699" data-mp="2ryezhz97u3rh" />
                </div>
                <div data-id="element-2700" data-mp="2wyjchfax0gcy">
                  <h4 className="font-bold text-lg mb-1" data-id="element-2701" data-mp="2wzujrp3kk68t">הדרכות קבוצתיות</h4>
                  <p className="text-gray-600 text-sm" data-id="element-2702" data-mp="2izjqygip8hl0">
                    אימונים קבוצתיים באווירה תומכת ומעצימה, מחולקים לפי רמות.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2703" data-mp="3apej0kxxyldd">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-2704" data-mp="3arr77fualryv">
                  <Award className="w-6 h-6 text-cyan-500" data-id="element-2705" data-mp="3fng1p4rggiob" />
                </div>
                <div data-id="element-2706" data-mp="31wb74h2y2gku">
                  <h4 className="font-bold text-lg mb-1" data-id="element-2707" data-mp="31wun3s91auw8">קהילה שוקקת</h4>
                  <p className="text-gray-600 text-sm" data-id="element-2708" data-mp="35xwejmwpm2nn">
                    הצטרפו לקהילת גולשים פעילה ומגובשת שחולקת את אהבת המים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2709" data-mp="2a4fr9ibfa40">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-2710" data-mp="2bz46xsspkcu">
                  <Radio className="w-6 h-6 text-cyan-500" data-id="element-2711" data-mp="2ukh3no8dlb4u" />
                </div>
                <div data-id="element-2712" data-mp="2zh7jqbk6k6q9">
                  <h4 className="font-bold text-lg mb-1" data-id="element-2713" data-mp="2zhqrx0k13gr3">
                    אירועי חתירה ספורטיביים
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-2714" data-mp="2kncfxjyvt7lx">
                    חתירות וטיולים חוויתיים, שקיעה וזריחה, חציית הכנרת ועוד
                    מפגשים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2715" data-mp="2gj4q1jgotlm4">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-2716" data-mp="2gk6a2dfolifz">
                  <Package className="w-6 h-6 text-cyan-500" data-id="element-2717" data-mp="21v9w5zqy1b7g" />
                </div>
                <div data-id="element-2718" data-mp="26t1y7mlaydpd">
                  <h4 className="font-bold text-lg mb-1" data-id="element-2719" data-mp="26umrl8vvrqln">אחסנת ציוד אישי</h4>
                  <p className="text-gray-600 text-sm" data-id="element-2720" data-mp="1stadl30a5z2e">
                    אפשרות לאחסון הציוד האישי שלכם במועדון בנוחות ובבטחה.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-2721" data-mp="1e6tqkry8op6o">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-2722" data-mp="1e7n369jvq8wq">
                  <Wind className="w-6 h-6 text-cyan-500" data-id="element-2723" data-mp="198scklfo7g22" />
                </div>
                <div data-id="element-2724" data-mp="1n7jivloajxfn">
                  <h4 className="font-bold text-lg mb-1" data-id="element-2725" data-mp="1n8untoth3b8c">
                    שימוש חופשי בציוד המועדון
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-2726" data-mp="1i7dovyujtyue">
                    חברי המועדון נהנים משימוש חופשי בציוד החתירה החדיש והאיכותי
                    של המועדון לחתירות עצמאיות.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-gray-200" data-id="element-2727" data-mp="25yj54f4eit58">
              <Button className="w-full text-lg py-6" onClick={() => document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-2728" data-mp="21wo47bqduhrz">
                רוצה להתחיל לעוף!
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Campaign Banner */}
      <section className="py-16 bg-gradient-to-r from-cyan-600 to-blue-600 text-white text-center" data-id="element-2729" data-mp="18khpv6ky7c9m">
        <div className="container mx-auto px-4" data-id="element-2730" data-mp="1cl1lg5pvi7tn">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-2731" data-mp="1clt7opxkyt79">
            מבצע מיוחד למצטרפים חדשים!
          </h2>
          <p className="text-xl mb-8 opacity-90" data-id="element-2732" data-mp="1hitckxip1pws">
            השאירו פרטים בדף הקמפיין שלנו וקבלו הצעה מיוחדת לשיעור היכרות
          </p>
          <a href="/wingfoil-campaign" className="inline-block bg-white text-cyan-600 font-bold text-lg py-4 px-10 rounded-full hover:bg-cyan-50 transition-colors shadow-lg hover:scale-105" data-id="element-2733" data-mp="1rb8uxvxwkgi7">
            למעבר לדף המבצע והשארת פרטים ←
          </a>
        </div>
      </section>

      <ContactSection data-id="element-2734" data-mp="25a8mpcgppbil" />
      <Footer data-id="element-2735" data-mp="25agwuwlga2q3" />
    </div>;
}